import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationStateService {
  private statusForCheckSuccessSubject = new BehaviorSubject<boolean>(false);
  private successDeviceListSubject = new BehaviorSubject<any[]>([]);
  private createNewPlanDeviceSubject = new BehaviorSubject<string | null>(null); 
  private notificationSubject = new BehaviorSubject<any[]>([]); 
  private planDetailsNotificationSubject = new BehaviorSubject<boolean>(false);
  private modificationSubject = new BehaviorSubject<boolean>(false);



  statusForCheckSuccess$ = this.statusForCheckSuccessSubject.asObservable();
  successDeviceList$ = this.successDeviceListSubject.asObservable();
  createNewPlanDevice$ = this.createNewPlanDeviceSubject.asObservable();
  notification$ = this.createNewPlanDeviceSubject.asObservable();
  planDetailsNotification$ = this.planDetailsNotificationSubject.asObservable();
  modificationStatus$ = this.modificationSubject.asObservable();





  setStatusForCheckSuccess(status: boolean) {
    this.statusForCheckSuccessSubject.next(status);
  }

  setSuccessDeviceList(devices: any[]) {
    this.successDeviceListSubject.next(devices);
  }

  
  setCreateNewPlanDevice(device: string) {
    this.createNewPlanDeviceSubject.next(device);
  }

  setNotification(notificatoins: any) {
    this.createNewPlanDeviceSubject.next(notificatoins);
  }
  setPlanNotification(notify: boolean) {
    this.planDetailsNotificationSubject.next(notify);
  }
  updateModiy(status: boolean) {
    this.modificationSubject.next(status);
  }
}
